const s = {
  name: "London",
  dimensions: { width: 16, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 16 40" style="enable-background:new 0 0 16 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,20c-2.8,0-5,2.2-5,5s2.2,5,5,5c2.8,0,5-2.2,5-5S10.8,20,8,20z M5,25c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3
			c0,1.7-1.3,3-3,3C6.3,28,5,26.7,5,25z"/>
		<path class="st0" d="M9,3.7l2,3V9h1.8l1.2,4.9V17h2v16h-1v7h-2v-7H3v7H1v-7H0V17h2v-3.1L3.2,9H5V6.7l2-3V0h2V3.7z M9,7.3L8,5.8
			L7,7.3V9h2V7.3z M2,31h12V19H2V31z M4,17h8v-2H4V17z M4.8,11l-0.5,2h7.4l-0.5-2H4.8z"/>
		<path class="st0" d="M9,40v-5h2v5H9z"/>
		<path class="st0" d="M5,35v5h2v-5H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as London
};
